
 export const SPECIAL_CHARACTERS: { name: string, symbol: string }[] = [
    {name:'copyright', symbol: '©'},
    {name:'REGISTERED', symbol: '®'},
    {name:'TRADEMARK', symbol: '™'},
    //arrows
    {name:'left arrow', symbol: '&#8592;'},
    {name:'up arrow', symbol: '&#8593;'},
    {name:'right arrow', symbol: '&#8594;'},
    {name:'down arrow', symbol: '&#8595;'},
    {name:'left right arrow', symbol: '&#8596;'},
    {name:'up down arrow', symbol: '&#8597;'},

    {name:'LEFTWARDS DASHED ARROW', symbol: '&#8672;'},
    {name:'UPWARDS DASHED ARROW', symbol: '&#8673;'},
    {name:'RIGHTWARDS DASHED ARROW', symbol: '&#8674;'},
    {name:'DOWNWARDS DASHED ARROW', symbol: '&#8675;'},
    {name:'LEFTWARDS ARROW TO BAR', symbol: '&#8676;'},
    {name:'RIGHTWARDS ARROW TO BAR', symbol: '&#8677;'},

    {name:'LEFTWARDS WHITE ARROW', symbol: '&#8678;'},
    {name:'UPWARDS WHITE ARROW', symbol: '&#8670;'},
    {name:'RIGHTWARDS WHITE ARROW', symbol: '&#8680;'},
    {name:'DOWNWARDS WHITE ARROW', symbol: '&#8681;'},

    //currency

    {name:'EURO-CURRENCY SIGN', symbol: '&#8352;'},
    {name:'COLON SIGN', symbol: '&#8353;'},
    {name:'CRUZEIRO SIGN', symbol: '&#8354;'},
    {name:'FRENCH FRANC SIGN', symbol: '&#8355;'},
    {name:'LIRA SIGN', symbol: '&#8356;'},
    {name:'MILL SIGN', symbol: '&#8357;'},
    {name:'NAIRA SIGN', symbol: '&#8358;'},
    {name:'PESETA SIGN', symbol: '&#8359;'},
    {name:'RUPEE SIGN', symbol: '&#8360;'},
    {name:'WON SIGN', symbol: '&#8361;'},
    {name:'NEW SHEQEL SIGN', symbol: '&#8362;'},
    {name:'DONG SIGN', symbol: '&#8363;'},
    {name:'EURO SIGN', symbol: '&#8364;'},
    {name:'KIP SIGN', symbol: '&#8365;'},
    {name:'TUGRIK SIGN', symbol: '&#8366;'},
    {name:'DRACHMA SIGN', symbol: '&#8367;'},
    {name:'GERMAN PENNY SYMBOL', symbol: '&#8368;'},
    {name:'PESO SIGN', symbol: '&#8369;'},
    {name:'GUARANI SIGN', symbol: '&#8370;'},
    {name:'AUSTRAL SIGN', symbol: '&#8371;'},
    {name:'HRYVNIA SIGN', symbol: '&#8372;'},
    {name:'CEDI SIGN', symbol: '&#8373;'},
    {name:'LIVRE TOURNOIS SIGN', symbol: '&#8374;'},
    {name:'SPESMILO SIGN', symbol: '&#8375;'},
    {name:'TENGE SIGN', symbol: '&#8376;'},
    {name:'INDIAN RUPEE SIGN', symbol: '&#8377;'},
    {name:'TURKISH LIRA SIGN', symbol: '&#8378;'},
    {name:'NORDIC MARK SIGN', symbol: '&#8379;'},
    {name:'MANAT SIGN', symbol: '&#8380;'},
    {name:'RUBLE SIGN', symbol: '&#8381;'},
    {name:'LARI SIGN', symbol: '&#8382;'},
    {name:'BITCOIN SIGN', symbol: '&#8383;'},

    //Latin Characters
    {name:'Latin capital letter A with grave', symbol: '&#192;'},
    {name:'Latin capital letter A with acute', symbol: '&#193;'},
    {name:'Latin capital letter A with circumflex', symbol: '&#194;'},
    {name:'Latin capital letter A with tilde', symbol: '&#195;'},
    {name:'Latin capital letter A with diaeresis', symbol: '&#196;'},
    {name:'Latin capital letter A with ring above', symbol: '&#197;'},
    {name:'Latin capital letter AE', symbol: '&#198;'},
    {name:'Latin capital letter C with cedilla', symbol: '&#199;'},
    {name:'Latin capital letter E with grave', symbol: '&#200;'},
    {name:'Latin capital letter E with acute', symbol: '&#201;'},
    {name:'Latin capital letter E with circumflex', symbol: '&#202;'},
    {name:'Latin capital letter E with diaeresis', symbol: '&#203;'},
    {name:'Latin capital letter I with grave', symbol: '&#204;'},
    {name:'Latin capital letter I with acute', symbol: '&#205;'},
    {name:'Latin capital letter I with circumflex', symbol: '&#206;'},
    {name:'Latin capital letter I with diaeresis', symbol: '&#207;'},
    {name:'Latin capital letter Eth', symbol: '&#208;'},
    {name:'Latin capital letter N with tilde', symbol: '&#209;'},
    {name:'Latin capital letter O with grave', symbol: '&#210;'},
    {name:'Latin capital letter O with acute', symbol: '&#211;'},
    {name:'Latin capital letter O with circumflex', symbol: '&#212;'},
    {name:'Latin capital letter O with tilde', symbol: '&#213;'},
    {name:'Latin capital letter O with diaeresis', symbol: '&#214;'},
    {name:'Latin capital letter U with grave', symbol: '&#216;'},
    {name:'Latin capital letter U with grave', symbol: '&#217;'},
    {name:'Latin capital letter U with acute', symbol: '&#218;'},
    {name:'Latin capital letter U with circumflex', symbol: '&#219;'},
    {name:'Latin capital letter U with diaeresis', symbol: '&#220;'},
    {name:'Latin capital letter Y with acute', symbol: '&#221;'},
    {name:'Latin capital letter Thorn', symbol: '&#222;'},
    {name:'Latin small letter sharp s', symbol: '&#223;'},
    {name:'Latin small letter a with grave', symbol: '&#224;'},
    {name:'Latin small letter a with acute', symbol: '&#225;'},
    {name:'Latin small letter a with circumflex', symbol: '&#226;'},
    {name:'Latin small letter a with tilde', symbol: '&#227;'},
    {name:'Latin small letter a with diaeresis', symbol: '&#228;'},
    {name:'Latin small letter a with ring above', symbol: '&#229;'},
    {name:'Latin small letter ae', symbol: '&#230;'},
    {name:'lLatin small letter c with cedilla', symbol: '&#231;'},
    {name:'Latin small letter e with grave', symbol: '&#232;'},
    {name:'Latin small letter e with acute', symbol: '&#233;'},
    {name:'Latin small letter e with circumflex', symbol: '&#234;'},
    {name:'Latin small letter e with diaeresis', symbol: '&#235;'},
    {name:'Latin small letter i with grave', symbol: '&#236;'},
    {name:'Latin small letter i with acute', symbol: '&#237;'},
    {name:'Latin small letter i with circumflex', symbol: '&#238;'},
    {name:'Latin small letter i with diaeresis', symbol: '&#239;'},
    {name:'Latin small letter eth', symbol: '&#240;'},
    {name:'Latin small letter n with tilde', symbol: '&#241;'},
    {name:'Latin small letter o with acute', symbol: '&#242;'},
    {name:'Latin small letter o with acute', symbol: '&#243;'},
    {name:'Latin small letter o with circumflex', symbol: '&#244;'},
    {name:'Latin small letter o with tilde', symbol: '&#245;'},
    {name:'Latin small letter o with diaeresis', symbol: '&#246;'},
    {name:'Latin small letter o with stroke', symbol: '&#248;'},
    {name:'Latin small letter u with grave', symbol: '&#249;'},
    {name:'Latin small letter u with acute', symbol: '&#250;'},
    {name:'Latin small letter u with circumflex', symbol: '&#251;'},
    {name:'Latin small letter u with diaeresis', symbol: '&#252;'},
    {name:'Latin small letter y with acute', symbol: '&#253;'},
    {name:'Latin small letter thorn', symbol: '&#254;'},
    {name:'Latin small letter y with diaeresis', symbol: '&#255;'},

   // Mathematical
    {name:'less-than sign', symbol: '&#60;'},
    {name:'greater-than sign', symbol: '&#62;'},
    {name:'Latin small letter u with acute', symbol: '&#250;'},
    {name:'Latin small letter u with circumflex', symbol: '&#251;'},
    {name:'low line', symbol: '&#95;'},
    {name:'macron', symbol: '&#175;'},
    {name:'en dash', symbol: '&#150;'},
    {name:'em dash', symbol: '&#151;'},
    {name:'Latin small letter f with hook', symbol: '&#131;'},
    {name:'degree sign', symbol: '&#176;'},
    {name:'plus-minus sign', symbol: '&#177;'},
    {name:'division sign', symbol: '&#247;'},
    {name:'multiplication sign', symbol: '&#215;'},
    {name:'vulgar fraction one quarter', symbol: '&#188;'},
    {name:'vulgar fraction one half', symbol: '&#189;'},
    {name:'vulgar fraction three quarters', symbol: '&#190;'},

    {name:'equals sign', symbol: '&#61;'},
    {name:'tilde', symbol: '&#126;'},
    {name:'solidus', symbol: '&#47;'},
    {name:'plus sign',symbol: '&#43;'},
    {name:'asterisk', symbol: '&#42;'},
    {name:'percent sign', symbol: '&#37;'},
    {name:'division sign', symbol: '&#247;'},
    {name:'ANGLE', symbol: '&#8735;'},
    {name:'N-ary Product', symbol: '&#8719;'},
    {name:'WHITE DOWN-POINTING TRIANGLE', symbol: '&#9661;'},
    {name:'Diameter sign', symbol: '&#8960;'},
    {name:'Up arrowhead', symbol: '&#8963;'},
    {name:'Down arrowhead', symbol: '&#8964;'},
    {name:'FOR ALL', symbol: '&#8704;'},
    {name:'THERE EXISTS', symbol: '&#8707;'},
    {name:'PARTIAL DIFFERENTIAL', symbol: '&#8706;'},
    {name:'ELEMENT OF', symbol: '&#8712;'},
    {name:'NOT AN ELEMENT OF', symbol: '&#8713;'},
    {name:'CONTAINS AS MEMBER', symbol: '&#8715;'},
    {name:'N-ARY SUMMATION', symbol: '&#8721;'},
    {name:'SQUARE ROOT', symbol: '&#8730;'},
    {name:'PROPORTIONAL TO', symbol: '&#8733;'},
    {name:'INFINITY', symbol: '&#8734;'},
    {name:'Latin small letter thorn', symbol: '&#254;'},
    {name:'Latin small letter y with diaeresis', symbol: '&#255;'},
    {name:'Latin small letter o with diaeresis', symbol: '&#246;'},
    {name:'division sign', symbol: '&#247;'},
    {name:'Latin small letter o with stroke', symbol: '&#248;'},
    {name:'Latin small letter u with grave', symbol: '&#249;'},
    {name:'Latin small letter u with acute', symbol: '&#250;'},
    {name:'Latin small letter u with circumflex', symbol: '&#251;'},
    {name:'Latin small letter u with diaeresis', symbol: '&#252;'},
    {name:'Latin small letter y with acute', symbol: '&#253;'},
    {name:'Latin small letter thorn', symbol: '&#254;'},
    {name:'Latin small letter y with diaeresis', symbol: '&#255;'},
    {name:'Latin small letter u with diaeresis', symbol: '&#252;'},
    {name:'Latin small letter y with acute', symbol: '&#253;'},
    {name:'Latin small letter thorn', symbol: '&#254;'},
    {name:'Latin small letter y with diaeresis', symbol: '&#255;'},
  ];
